var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShowPass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.12421 1.04075C10.0521 0.830404 12.0443 1.21178 13.7451 2.13316C15.7205 3.18213 17.2816 4.94489 18.1082 6.99937C17.5429 8.3904 16.6548 9.65523 15.5116 10.6442C14.0428 11.9339 12.1589 12.7559 10.203 12.958C8.50015 13.1414 6.74623 12.8704 5.18938 12.1635C2.93654 11.1635 1.12603 9.26351 0.219727 6.99868C0.785031 5.60971 1.67177 4.34696 2.81286 3.35868C4.28237 2.06765 6.16695 1.24351 8.12421 1.04075ZM8.43027 3.05523C7.06837 3.28971 5.87487 4.26627 5.38014 5.53868C5.02237 6.43523 5.00909 7.46006 5.3438 8.36489C5.69179 9.32144 6.4248 10.1332 7.34648 10.5856C8.19898 11.0118 9.2073 11.1194 10.1346 10.8932C11.1604 10.649 12.0744 9.98833 12.6236 9.09937C13.2022 8.18696 13.3727 7.03868 13.098 5.99799C12.843 5.00351 12.1792 4.11937 11.2917 3.58489C10.449 3.06489 9.40645 2.8773 8.43027 3.05523Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9082 4.60667C10.0905 4.45908 11.2847 5.29977 11.5349 6.44736C11.8318 7.57771 11.1512 8.84392 10.0416 9.24323C8.95711 9.68461 7.6029 9.20461 7.04458 8.18874C6.46041 7.22254 6.70428 5.87702 7.58543 5.16598C7.95648 4.85495 8.42325 4.65563 8.9082 4.60667Z",
    fill: "#828282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPass);
export default __webpack_public_path__ + "static/media/show-pass.19bf426d4524deb63202ddb8734c248c.svg";
export { ForwardRef as ReactComponent };